<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },

  data() {
    return {
      phaseOneShow: false,
      show_serviceCategory: null,
      tData: {
        servicesPartsTable: [
          {
            code: "SC - 005",
            name: "Ganti Oli",
            serviceCategory: "Jenis Servis",
            status: "A",
          },
          {
            code: "SC - 004",
            name: "Spooring Roda",
            serviceCategory: "Jenis Servis",
            status: "I",
          },
        ],
      },
      selected: {
        servicesPartsTable: [],
      },
      selectedModel: {
        servicesPartsTable: [],
      },
      allSelected: {
        servicesPartsTable: false,
      },
      indeterminate: {
        servicesPartsTable: true,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "code",
      show_model: [],
      show: [
        { key: "code", label: "Kode Jasa" },
        { key: "name", label: "Nama Jasa" },
        { key: "serviceCategory", label: "Jenis Jasa" },
        { key: "status", label: "Status" },
      ],
      modalUpdateStatus: false,
    };
  },

  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tData.servicesPartsTable.length;
    },

    totalTrue() {
      return this.selectedModel.servicesPartsTable.filter((c) => c === true);
    },

    servicesPartsTable() {
      return [
        {
          key: "columnCheck",
          thClass: "mc-table--30",
          sortable: false,
        },
        {
          key: "code",
          thClass: "mc-table--50",
          label: "Kode Jasa",
          sortable: true,
        },
        {
          key: "name",
          thClass: "mc-table--50",
          label: "Nama Jasa",
          sortable: true,
        },
        {
          key: "serviceCategory",
          thClass: "mc-table--50",
          label: "Jenis Jasa",
          sortable: true,
        },
        {
          key: "status",
          thClass: "mc-table--50",
          label: "Status",
          sortable: true,
        },
      ];
    },
  },

  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    toggleAll(checked, param) {
      this.selectedModel[param] = [];
      this.selected[param] = [];
      if (checked) {
        for (let i = 0; i < this.tData[param].length; i++) {
          this.selected[param].push(i);
          this.selectedModel[param].push(true);
        }
      } else {
        for (let i = 0; i < this.tData[param].length; i++) {
          this.selectedModel[param].push(false);
        }
        this.selected[param] = [];
      }
    },

    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data.index);
      } else {
        var myIndex = this.selected[param].indexOf(data.index);
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1);
        }
      }
    },

    toDelete(param) {
      this.selected[param].sort();
      this.selected[param].reverse();
      this.selected[param].forEach((row) => {
        this.$delete(this.tData[param], row);
      });
      this.selected[param] = [];
      this.selectedModel[param] = [];

      this.indeterminate[param] = false;
      this.allSelected[param] = false;
      for (let i = 0; i < this.tData[param].length; i++) {
        this.selectedModel[param].push(false);
      }
    },

    clearCheck() {
      this.selected = {
        servicesPartsTable: [],
      };

      this.selectedModel = {
        servicesPartsTable: [],
      };
    },

    showUpdateStatus(status) {
      this.status = status;
      this.modalUpdateStatus = true;
    },
  },
};
</script>
    
    <template>
  <b-tab class="border-0" active>
    <template v-slot:title>
      <span class="d-sm-inline-block">Jasa</span>
    </template>

    <div class="mc-list-header">
      <div class="clearfix mb-3 pb-3 border-3 border-bottom">
        <div class="float-end">
          <b-dropdown
            variant="outline-primary"
            class="me-3"
            v-if="selected.servicesPartsTable.length"
          >
            <template v-slot:button-content>
              Ubah Status
              <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item @click="showUpdateStatus('A')"
              >Aktif</b-dropdown-item
            >
            <b-dropdown-item @click="showUpdateStatus('I')"
              >Inaktif</b-dropdown-item
            >
            <b-modal
              v-model="modalUpdateStatus"
              title="Ubah Status"
              body-class="p-3"
              hide-footer
              size="md"
              centered
            >
              <form>
                <div class="row">
                  <p>
                    Apakah anda yakin mengubah status data berikut menjadi
                    <b v-if="status === 'A'">Aktif</b>
                    <b v-if="status === 'I'">Inaktif</b> ?
                  </p>

                  <div class="table-responsive">
                    <table class="table table-bordered mb-0">
                      <thead>
                        <tr></tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(row, index) in selected.servicesPartsTable"
                          :key="index"
                        >
                          <td>{{ row.code }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="text-end pt-5 mt-3">
                  <b-button
                    variant="outline-primary"
                    class="mx-2"
                    @click="modalUpdateStatus = false"
                    >Tidak</b-button
                  >
                  <b-button
                    @click="updateByStatus('servicesPartsTable')"
                    variant="primary"
                    class="ms-1"
                    >Ya</b-button
                  >
                </div>
              </form>
            </b-modal>
          </b-dropdown>
          <b-button
            v-if="selected.servicesPartsTable.length"
            v-b-modal.modal-delete
            variant="outline-danger"
          >
            <i class="mc-fa icon-outline_trash"></i>
            {{ $t("global.delete") }}
          </b-button>
          <b-button variant="primary" class="ms-2" v-b-modal.addFleet>
            <i class="mc-fa icon-outline_plus"></i>
            {{ $t("global.addField") }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
                <h6 v-if="totalTrue.length" class="mc-row-check">
                  <span class="badge btn-success">{{ totalTrue.length }}</span>
                  Baris terpilih.
                  <a class="color-primary" @click="clearCheck"
                    >Bersihkan semua</a
                  >
                </h6>
              </div>

              <!-- Search -->
              <div
                class="
                  col-sm-8 col-md-8
                  d-flex
                  flex-row-reverse
                  mc-table-view-wrapper
                "
              >
                <div class="mc-table-view">
                  <p class="mc-label">Tampilkan</p>
                  <multiselect
                    v-model="show_model"
                    :options="show"
                    :multiple="true"
                    placeholder="Semua Kolom"
                    track-by="label"
                    label="label"
                  ></multiselect>
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label
                      class="
                        d-inline-flex
                        align-items-center
                        mc-table-view__search
                      "
                    >
                      <i class="mc-fa fas fa-search"></i>
                      <b-form-input
                        v-model="filter"
                        type="search"
                        :placeholder="$t('global.search') + '...'"
                        class="ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive my-3 border border-1">
              <b-table
                small
                show-empty
                :fields="servicesPartsTable"
                :items="tData.servicesPartsTable"
                class="datatables"
                responsive="sm"
                sort-by="code"
                empty-table
                :empty-text="$t('global.emptyTable')"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #head(columnCheck)>
                  <div class="form-check">
                    <b-form-checkbox
                      @change="toggleAll($event, 'servicesPartsTable')"
                      v-model="allSelected.servicesPartsTable"
                      :indeterminate="indeterminate.servicesPartsTable"
                      :value="true"
                      :unchecked-value="false"
                    ></b-form-checkbox>
                  </div>
                </template>

                <template #cell(columnCheck)="data">
                  <div class="form-check">
                    <b-form-checkbox
                      @change="checkTable($event, data, 'servicesPartsTable')"
                      v-model="selectedModel.servicesPartsTable[data.index]"
                      :value="true"
                      :unchecked-value="false"
                    ></b-form-checkbox>
                  </div>
                </template>
                <template #cell(code)="data">
                  <strong class="text-primary" v-b-modal.addFleet>
                    {{ data.item.code }}
                  </strong>
                </template>
                <template #cell(status)="data">
                  <span
                    class="mc-status mc-status--green"
                    v-if="data.item.status === 'A'"
                  >
                    Aktif
                  </span>
                  <span
                    class="mc-status mc-status--grey"
                    v-else-if="data.item.status === 'I'"
                  >
                    Inaktif
                  </span>
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("global.show") }}
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    entri
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for Delete Confirmation -->
    <b-modal
      class="mc-modal"
      id="modal-delete"
      title="Hapus"
      size="md"
      centered
      scrollable
    >
      <div class="card-body mc-modal__filter p-2">
        <p>Apakah Anda yakin menghapus data berikut?</p>
        <b-list-group>
          <b-list-group-item>SC - 004</b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-2">
              Tidak
            </b-button>
            <b-button @click="toDelete" variant="primary"> Ya </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <b-modal
      class="mc-modal"
      id="addFleet"
      ref="addFleet"
      title="Jasa Pemeliharaan baru"
      header-bg-variant="primary"
      header-close-variant="light"
      ok-title="Simpan"
      cancel-title="Batal"
      cancel-variant="outline-primary"
      size="lg"
      centered
    >
      <b-row>
        <b-col md="6" class="mb-3">
          <b-form-group
            label="Nama Jasa"
            label-for="detailService"
            label-class="required"
          >
            <b-input-group>
              <b-form-input
                id="detailService"
                trim
                placeholder="Masukkan Nama Detail Servis"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="6" class="mb-3">
          <label class="required">Jenis Jasa</label>
          <multiselect
            :options="['Tipe 1', 'Tipe 2']"
            v-model="show_serviceCategory"
            placeholder="Jenis Jasa"
          >
          </multiselect>
        </b-col>
        <b-col md="6" class="mb-3">
          <b-form-group label="Biaya per Satuan" label-for="cost">
            <b-input-group prepend="Rp">
              <b-form-input
                id="cost"
                trim
                placeholder="Masukkan Biaya per Satuan"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Deskripsi" label-for="desc">
            <b-input-group>
              <b-form-input
                id="desc"
                trim
                placeholder="Masukkan Nama Deskripsi"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-tab>
</template>